import { css } from 'styled-components';
import React from 'react';

export interface IActionCssProps {
  onClick?: React.MouseEventHandler;
  href?: string;
}

export const useActionCss = css<IActionCssProps>`
  ${({ onClick, href }: IActionCssProps) =>
    (onClick || href) &&
    css`
      cursor: pointer;
    `};
`;

export interface INoTextDecorationProps {
  noTextDecoration?: boolean;
}

export const useActionOnTextCss = css<IActionCssProps & INoTextDecorationProps>`
  ${useActionCss}
  ${({ onClick, noTextDecoration, href }: IActionCssProps & INoTextDecorationProps) =>
    (onClick || href) &&
    !noTextDecoration &&
    css`
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    `};
`;

export interface IInvalidProps {
  invalid?: boolean;
}

export interface IForceFocusOutline {
  forceOutline?: boolean;
}

export type BaseFocusCssProps = IInvalidProps & IForceFocusOutline;
export const useBaseFocusCss = css<BaseFocusCssProps>`
  &:focus-visible,
  &:has(:focus-visible) {
    box-shadow: ${({ theme, invalid, forceOutline }) =>
      `${invalid ? theme.focusColours.invalid.boxShadow : theme.focusColours.boxShadow}${
        forceOutline
          ? // Note: using !important because react-select has "outline: 0!important"
            // (┛ಠ_ಠ)┛彡┻━┻
            `!important`
          : ''
      }`};
  }
`;

export const useFocusCss = (offset?: boolean) => css`
  ${useBaseFocusCss};

  ${offset &&
  css`
    outline-offset: ${({ theme }) => `-${theme.spaces[2]}`};
  `}
`;

export type PassedFocusCssProps = { focused?: boolean } & IInvalidProps & IForceFocusOutline;
export const usePassedFocusCss = css<PassedFocusCssProps>`
  // Fake focus
  // usually passed to container by child input
  ${({ focused }) => focused && useBaseFocusCss}
`;
